import { FulfillmentStatus } from "common/types/fulfillments";
import { OrderStatus } from "common/types/orders";

import type { StatusColor } from "client/common/components/content/Status";

type OrderStatusMetadata = {
  label: string;
  color: StatusColor;
};

const orderStatusToMetadata: Record<OrderStatus, OrderStatusMetadata> = {
  [OrderStatus.ApprovalNeeded]: {
    label: "Pending approval",
    color: "warning",
  },
  [OrderStatus.Approved]: {
    label: "Approved",
    color: "warning",
  },
  [OrderStatus.PaymentFailed]: {
    label: "Payment failed",
    color: "danger",
  },
  [OrderStatus.SentToVendor]: {
    label: "In progress",
    color: "warning",
  },
  [OrderStatus.Triaged]: {
    label: "In progress",
    color: "warning",
  },
  [OrderStatus.Shipped]: {
    label: "Shipped",
    color: "warning",
  },
  [OrderStatus.Completed]: {
    label: "Completed",
    color: "success",
  },
  [OrderStatus.Canceled]: {
    label: "Canceled",
    color: "danger",
  },
};

export const getLabelForOrderStatus = (status: OrderStatus): string => {
  return orderStatusToMetadata[status]?.label ?? "Unknown";
};

export const getColorForOrderStatus = (status: OrderStatus): StatusColor => {
  return orderStatusToMetadata[status]?.color ?? "greyscale";
};

const exhaustiveFulfillmentCheck = (status: never) => {
  console.warn(`Missing fulfillment status label for ${status}`);
  return "Unknown";
};

export const getLabelForFulfillmentStatus = (status: FulfillmentStatus) => {
  switch (status) {
    case FulfillmentStatus.Completed:
      return "Picked up";
    case FulfillmentStatus.MissedPickup:
      return "Missed pickup";
    case FulfillmentStatus.ReadyForPickup:
      return "Ready for pickup";
    case FulfillmentStatus.ReadyToPick:
    case FulfillmentStatus.ReadyToShip:
    case FulfillmentStatus.ReadyToReview:
      return "Processing";
    case FulfillmentStatus.Canceled:
      return "Canceled";
    default:
      return exhaustiveFulfillmentCheck(status);
  }
};
